import React from 'react'
import { Link } from 'react-router-dom'

const ContentModel = ({contentModel, language}) => {
    return (
        <label key={contentModel.id}  className="list-item" >
            <span className="checkbox-container">
                <i className={`sprite-icon ${contentModel.modelIcon === 'page' ? 'icon-document' : 'icon-menu'}`}></i>
            </span>
            <span className="name-container">{contentModel.modelName}</span>
            <span className="type-container">{contentModel.modelIcon}</span>
            <span className="published-container">{contentModel.modelType}</span>
            <span className="edit-container">
                <Link to={`/control/contentModels/${contentModel.id}`}>
                    <i className="sprite-icon icon-arrow-next"></i>
                </Link>
            </span>
        </label>
    )
}

export default ContentModel
